import React from 'react'

import { useCalendar } from './CalendarHandler'
import Placeholder from '../loader/Placeholder'

const DayPlaceholder = () => {
  const { loading } = useCalendar()
  if (!loading) return false

  return (
    <>
      <Placeholder marginBottom={0.5} minHeight={1} radius={0.2} />
      <Placeholder marginBottom={0.5} minHeight={1} radius={0.2} />
      <Placeholder marginBottom={0.5} minHeight={1} radius={0.2} />
    </>
  )
}

export default DayPlaceholder
